// import React from 'react'

// const Hero = () => {
//   return (
//     <div className='HeroWrap'>
//         <div className='Hero'>
//             <div className='HeroLeft'>
//                 <h1>Hi, I am Engr. Chinedu Joseph Ndu</h1>
//                 <p>| Civil Engineer | Quantity Surveyor | Asset Manager |</p>
//             </div>
//             <div className='HeroRight'>
//                 <img src="" alt="ProfilePic"/>
//                 <a href="https://www.freepik.com/free-photo/building-construction_1013363.htm#fromView=search&page=1&position=0&uuid=460e8a2d-f5ca-499d-b31f-bad9de283123">Image by freestockcenter on Freepik</a>
//                 <a href="https://www.freepik.com/free-photo/modern-buildings-boats-san-diego-usa_8826372.htm#fromView=search&page=1&position=34&uuid=a16ddbdd-e09f-402e-92bc-1b09cf80a8f8">Image by frimufilms on Freepik</a>
//             </div>
//         </div>
//     </div>
//   )
// }

// export default Hero


import React from 'react';
import "../CSS/Hero.css"
import HeroImage from "../Images/Ambassador.jpeg"

const Hero = () => {
  return (
    <div className='HeroWrap'>
      <div className='Hero'>
      <div className='HeroLeft'>
          <h1>Engr. Chinedu Joseph Ndu</h1>
         <div style={{boxShadow:"0px 4px 10px rgba(0,0,100)",padding:"5px"}}>
         <p>MNSE, MNICE, COREN </p>
          <p>+234 803 090 6974</p>
          <p>neduforad@yahoo.com</p>
         </div>
        </div>
      <div className='HeroRight'>
          <img src={HeroImage} alt="ProfilePic"/>
          <div>
          {/* <a href="https://www.freepik.com/free-photo/modern-buildings-boats-san-diego-usa_8826372.htm#fromView=search&page=1&position=34&uuid=a16ddbdd-e09f-402e-92bc-1b09cf80a8f8">Image by frimufilms on Freepik</a> */}
          </div>
        </div>
        
        
      </div>
    </div>
  );
};

export default Hero;

